import curry from "../../../../lib/core/functional/curry";

const renderModule = curry(function renderModule(preact, _context, {}, _altLoader) {
    const { h } = preact;
    function Module(props) {
        const {
            siteName,
            siteTitle,
            siteAvatar,
            message,
            permalink,
            fullDate,
            date,
            isUnread,
        } = props;

        const displayDate = (
            <p class="date" title={fullDate}>
                {date}
            </p>
        );
        return (
            <li class={isUnread ? " is_unread" : ""}>
                <div class="river-notification clearfix">
                    <div class="aside">
                        <a
                            href={`/community/${siteName}`}
                            class="author permalink_author"
                            title={siteTitle}
                            target="_blank"
                        >
                            <img src={siteAvatar} width="35" />
                        </a>
                    </div>
                    <div class="content-wrp">
                        <p class="title" dangerouslySetInnerHTML={{ __html: message }}></p>
                        {permalink ? (
                            <a href={permalink} target="_blank">
                                {displayDate}
                            </a>
                        ) : (
                            displayDate
                        )}
                    </div>
                </div>
            </li>
        );
    }
    return Module;
});

export default function riverNotification({ preact }) {
    return renderModule(preact);
}
